import { EMAIL_REGEX_ADDRESS } from './constants';

export function isValidEmail(email) {
  return EMAIL_REGEX_ADDRESS.test(email);
}
